module.exports = __webpack_public_path__ + "ff247b3ad8de42e898911e2ca9677bb2.png";